/* eslint-disable max-lines */
// Custom Messages
export const roCustomMessages = {
    // navigation
    'navbar.company': 'Companie',
    'navbar.language.en': 'Engleză',
    'navbar.language.ro': 'Română',
    'navbar.logout': 'Ieșire',

    // menu
    'menu.label.home': 'Acasă',
    'menu.label.cf-document': 'CF-Document',

    // login page
    'login.fieldUsername': 'Introduceți utilizatorul',
    'login.fieldPassword': 'Introduceți parola',
    'login.loginBtn': 'Autentificare',
    'login.clear': 'Resetare',
    'login.textLoading': 'Încărcare...',
    'login.errorUsername': 'Utilizatorul este necesar',
    'login.errorPassword': 'Parola este necesară',
    'login.tokenExpiredOrInvalid': 'Token-ul este expirat sau invalid. Te rugăm să te loghezi din nou.',
    'login.loginError': 'Eroare la logare.',

    // home page
    'home.cardInvoice.title': 'CloudFlow4Invoice',
    'home.cardInvoice.paragraph-1': 'Sistem inteligent de emitere factură electronică eFactura',
    'home.cardInvoice.bullet-1': 'Emitere diferite tipuri de e-facturi (factură, autofactură, corectare)',
    'home.cardInvoice.bullet-2': 'Export și printare  eFacturi',
    'home.cardInvoice.link': 'Mergi la secțiunea CloudFlow4Invoice',
    'home.cardTransport.title': 'CloudFlow4Trans',
    'home.cardTransport.paragraph-1': 'Platformă inteligentă pentru gestionarea documentului eCMR în domeniul transporturilor',
    'home.cardTransport.bullet-1': 'Emitere document eCMR',
    'home.cardTransport.bullet-2': 'Modificare și adăugare evenimente eCMR-ului',
    'home.cardTransport.bullet-3': 'Monitorizare transparență și notificare participanți cu privire la documente eCMR',
    'home.cardTransport.link': 'Mergi la secțiunea CloudFlow4Trans',

    // cf-document page
    'cf-document.label.title': 'Vizualizare CF Document',
    'cf-document.control.module': 'Modul',
    'cf-document.control.documentNumber': 'Număr document',
    'cf-document.control.companyId': 'Id-ul companiei',
    'cf-document.button.search': 'Caută',
    'cf-document.button.map': 'Hartă',
    'cf-document.button.blockchain': 'Blockchain',
    'cf-document.button.download-pdf': 'Descarcă',
    'cf-document.grid.document-info-section': 'Informații document',
    'cf-document.grid.document-sections': 'Secțiuni semnare',
    'cf-document.grid.available-actions-section': 'Acțiuni disponibile',
    'cf-document.expansion-panel.fine-registration': 'Înregistrare amendă',
    'cf-document.expansion-panel.sign': 'Semnează',
    'cf-document.label.id': 'Id CloudFlow',
    'cf-document.label.externalId': 'Id extern',
    'cf-document.label.documentType': 'Tip document',
    'cf-document.label.documentNumber': 'Număr document',
    'cf-document.label.companyId': 'Id companie',
    'cf-document.label.documentState': 'Stare document',
    'cf-document.label.publishDate': 'Dată publicare',
    'cf-document.label.publisherEmail': 'Email',
    'cf-document.label.documentHash': 'Hash-ul documentului',
    'cf-document.label.contractAddress': 'Adresa contractului',
    'cf-document.label.webhookUrl': 'Webhook url',
    'cf-document.tab.files.title': 'Versiuni document',
    'cf-document.tab.attachments.title': 'Atașamente',
    'cf-document.tab.events.title': 'Evenimente',
    'cf-document.notification.documentNotLoaded':
        'Te rugăm să selectezi modulul și să introduci numărul documentului și id-ul companiei, apoi apasă butonul "Caută"!',
    'cf-document.notification.documentFound': 'Document găsit!',
    'cf-document.notification.documentError': 'Documentul căutat nu a fost găsit!',
    'cf-document.tab.files.column.version': 'Versiune',
    'cf-document.tab.files.column.fileName': 'Numele fișierului',
    'cf-document.tab.files.column.extension': 'Extensia fișierului',
    'cf-document.tab.files.column.downloadSuccess': 'Fișierul s-a descărcat cu succes.',
    'cf-document.tab.files.column.downloadError': 'A intervenit o eroare la descărcarea fișierului!',
    'cf-document.tab.events.column.title': 'Titlu',
    'cf-document.tab.events.column.type': 'Tip eveniment',
    'cf-document.tab.events.column.hasAttachment': 'Are atașament?',
    'cf-document.tab.events.column.mention': 'Mențiune',
    'cf-document.tab.events.column.section': 'Aplicat pe secțiunea',
    'cf-document.tab.events.column.documentHash': 'Hash-ul documentului',
    'cf-document.tab.events.column.blockchainStatus': 'Status blockchain',

    // cf-signature
    'cf-signature.control.section': 'Secțiune',
    'cf-signature.control.signatureType': 'Modalitate de semnare',
    'cf-signature.control.signer': 'Semnatar',
    'cf-signature.button.initiateSign': 'Inițiază semnătura',
    'cf-signature.dialog.signWithPin.title': 'Semnează cu pin',
    'cf-signature.dialog.signWithPin.column.pin': 'PIN',
    'cf-signature.dialog.signWithPinPatternRequired': 'Valoarea inserată nu este formată din 4 numere',
    'cf-signature.dialog.signOnGlass.title': 'Semnează pe sticlă',
    'cf-signature.dialog.signOnGlassRequired': 'Este obligatoriu să desenați o semnătură',
    'cf-signature.notification.signatureComplete': 'Secțiunea a fost salvată cu success!',
    'cf-signature.notification.signatureInitError': 'A apărut o eroare la inițializarea procesului de semnare!',
    'cf-signature.notification.signatureCompleteError': 'A apărut o eroare la semnarea secțiuni!',

    // cf-event
    'cf-event.notification.copiedTxId': 'Hash-ul tranzacției a fost copiat în clipboard',

    // company-tasks
    'cf-company-tasks.dialog.registerEventDialog.title': 'Înregistrează eveniment',
    'cf-company-tasks.dialog.registerEventDialog.label.mention': 'Mențiune',
    'cf-company-tasks.dialog.registerEventDialog.label.file': 'Fișier',
    'cf-company-tasks.notification.eventRegistered': 'Evenimentul a fost inregistrat cu success!',

    // cf document anonymous
    'cf-document-anonymous.label.greeting': 'Salut',
    'cf-document-anonymous.label.sign-title': 'mai jos puteți vizualiza și semna documentul ...',
    'cf-document-anonymous.label.view-title': 'mai jos puteți vizualiza documentul ...',

    // cf signature anonymous
    'cf-signature-anonymous.label.title': 'Semnare CF Document',

    // thanks for signing
    'thanks-for-signing.label.title': 'Vă mulțumesc!',
    'thanks-for-signing.label.paragraph-1': 'Semnătura dumneavoastră a fost aplicată cu success.',
    'thanks-for-signing.label.paragraph-2': 'Puteți descărca ultima versiune a documentului prin apăsarea următorului link: ',
    'thanks-for-signing.label.download-document': 'Descarcă document',

    // grid
    'grid.columns.actions': 'Acțiuni',
    'grid.columns.createdAt': 'Creat la',
    'grid.columns.createdBy': 'Creat de',

    // labels
    'labels.download': 'Descarcă',
    'labels.refresh': 'Reîncărcare',
    'labels.yes': 'Da',
    'labels.no': 'Nu',
    'labels.map': 'Hartă',
    'labels.copyToClipboard': 'Copiază în clipboard',
    'labels.save': 'Salvează',
    'labels.cancel': 'Anulează',
    'labels.sign': 'Semnează',

    // form error
    'input.required.error': 'Câmp obligatoriu!',
    'file-select.required.error': 'Fișierul este necesar'
};

// Kendo Angular Component Messages
export const roComponentMessages = {
    // Grid
    'kendo.grid.groupPanelEmpty': 'Trage de o coloană și las-o aici pentru a grupa după acea coloană',
    'kendo.grid.noRecords': 'Nu există înregistrări.',
    'kendo.grid.pagerFirstPage': 'Prima pagină',
    'kendo.grid.pagerPreviousPage': 'Pagina anterioară',
    'kendo.grid.pagerNextPage': 'Pagina următoare',
    'kendo.grid.pagerLastPage': 'Ultima pagină',
    'kendo.grid.pagerPage': 'Pagină',
    'kendo.grid.pagerOf': 'din',
    'kendo.grid.pagerItems': 'înregistrări',
    'kendo.grid.pagerItemsPerPage': 'înregistrări pe pagină',
    'kendo.grid.pagerPageNumberInputTitle': 'Nr pagină',
    'kendo.grid.filter': 'Filtru',
    'kendo.grid.filterEqOperator': 'Egal cu',
    'kendo.grid.filterNotEqOperator': 'Nu e egal cu',
    'kendo.grid.filterIsNullOperator': 'E null',
    'kendo.grid.filterIsNotNullOperator': 'Nu e null',
    'kendo.grid.filterIsEmptyOperator': 'E gol',
    'kendo.grid.filterIsNotEmptyOperator': 'Nu e gol',
    'kendo.grid.filterStartsWithOperator': 'Începe cu',
    'kendo.grid.filterContainsOperator': 'Conține',
    'kendo.grid.filterNotContainsOperator': 'Nu conține',
    'kendo.grid.filterEndsWithOperator': 'Se termină cu',
    'kendo.grid.filterGteOperator': 'E mai mare sau egal cu',
    'kendo.grid.filterGtOperator': 'E mai mare decât',
    'kendo.grid.filterLteOperator': 'E mai mic sau egal cu',
    'kendo.grid.filterLtOperator': 'E mai mic decât',
    'kendo.grid.filterIsTrue': 'e adevărat',
    'kendo.grid.filterIsFalse': 'e fals',
    'kendo.grid.filterBooleanAll': '(Toate)',
    'kendo.grid.filterAfterOrEqualOperator': 'E după sau egal cu',
    'kendo.grid.filterAfterOperator': 'E după',
    'kendo.grid.filterBeforeOperator': 'E înainte',
    'kendo.grid.filterBeforeOrEqualOperator': 'E înainte sau egal cu',
    'kendo.grid.filterFilterButton': 'Filtru',
    'kendo.grid.filterClearButton': 'Șterge',
    'kendo.grid.filterAndLogic': 'Și',
    'kendo.grid.filterOrLogic': 'Sau',
    'kendo.grid.filterDateToggle': 'Toggle calendar',
    'kendo.grid.filterDateToday': 'Azi',
    'kendo.grid.filterNumericDecrement': 'Decrementează valoare',
    'kendo.grid.filterNumericIncrement': 'Incrementează valoare',
    'kendo.grid.loading': 'Încărcare',
    'kendo.grid.sort': 'Sortare',
    'kendo.grid.columnMenu': 'Meniu coloană',
    'kendo.grid.columns': 'Coloane',
    'kendo.grid.lock': 'Lock',
    'kendo.grid.unlock': 'Unlock',
    'kendo.grid.stick': 'Stick',
    'kendo.grid.unstick': 'Unstick',
    'kendo.grid.setColumnPosition': 'Setare poziție coloană',
    'kendo.grid.sortAscending': 'Sortare ascendent',
    'kendo.grid.sortDescending': 'Sortare descendent',
    'kendo.grid.columnsApply': 'Aplică',
    'kendo.grid.columnsReset': 'Reset',
    'kendo.grid.sortable': 'Sortabil',
    'kendo.grid.sortedAscending': 'Sortat ascendent',
    'kendo.grid.sortedDescending': 'Sortat descendent',
    'kendo.grid.sortedDefault': 'Nesortat',

    // DropDowns
    'kendo.autocomplete.noDataText': 'Nu s-au găsit date',
    'kendo.autocomplete.clearTitle': 'Șterge',
    'kendo.combobox.noDataText': 'Nu s-au găsit date',
    'kendo.combobox.clearTitle': 'Șterge',
    'kendo.dropdownlist.noDataText': 'Nu s-au găsit date',
    'kendo.dropdownlist.clearTitle': 'Șterge',

    // Calendar
    'kendo.calendar.today': 'AZI',

    // TextBox
    'kendo.textbox.clearTitle': 'Șterge',

    // DatePicker
    'kendo.datepicker.today': 'AZI',
    'kendo.datepicker.toggle': 'Toggle calendar',

    // DateInput
    'kendo.dateinput.increment': 'Incrementează valoare',
    'kendo.dateinput.decrement': 'Decrementează valoare',

    // NumericTextBox
    'kendo.numerictextbox.increment': 'Incrementează valoare',
    'kendo.numerictextbox.decrement': 'Decrementează valoare',

    // DateTimePicker
    'kendo.datetimepicker.dateTab': 'Date',
    'kendo.datetimepicker.dateTabLabel': 'Data',
    'kendo.datetimepicker.timeTab': 'Timp',
    'kendo.datetimepicker.timeTabLabel': 'Timp',
    'kendo.datetimepicker.toggle': 'Glisează popup',
    'kendo.datetimepicker.accept': 'Set',
    'kendo.datetimepicker.acceptLabel': 'Set',
    'kendo.datetimepicker.cancel': 'Anulare',
    'kendo.datetimepicker.cancelLabel': 'Anulare',
    'kendo.datetimepicker.now': 'ACUM',
    'kendo.datetimepicker.nowLabel': 'Selectare acum',
    'kendo.datetimepicker.today': 'AZI',
    'kendo.datetimepicker.prevButtonTitle': 'Navigare la view anterior',
    'kendo.datetimepicker.nextButtonTitle': 'Navigare la view următor',

    // TimePicker
    'kendo.timepicker.accept': 'Set',
    'kendo.timepicker.acceptLabel': 'Set',
    'kendo.timepicker.cancel': 'Anulare',
    'kendo.timepicker.cancelLabel': 'Anulare',
    'kendo.timepicker.now': 'Acum',
    'kendo.timepicker.nowLabel': 'Acum',
    'kendo.timepicker.toggle': 'Glisează lista timpului',

    // FileSelect
    'kendo.fileselect.cancel': 'Anulare',
    'kendo.fileselect.clearSelectedFiles': 'Șterge',
    'kendo.fileselect.dropFilesHere': 'Lasă fișiere aici pentru a le încărca',
    'kendo.fileselect.externalDropFilesHere': 'Trage și lasă fișiere aici pentru a le încărca',
    'kendo.fileselect.filesBatchStatus': 'fișiere',
    'kendo.fileselect.filesBatchStatusFailed': 'fișierele nu au fost încărcate.',
    'kendo.fileselect.filesBatchStatusUploaded': 'fișierele au fost încărcate cu succes.',
    'kendo.fileselect.fileStatusFailed': 'Fișierul nu a fost încărcat.',
    'kendo.fileselect.fileStatusUploaded': 'Fișierul a fost încărcat cu succes.',
    'kendo.fileselect.headerStatusPaused': 'Oprit',
    'kendo.fileselect.headerStatusUploaded': 'Terminat',
    'kendo.fileselect.headerStatusUploading': 'Încărcare...',
    'kendo.fileselect.invalidFileExtension': 'Tip de fișier nepermis.',
    'kendo.fileselect.invalidMaxFileSize': 'Dimensiune fișier prea mare.',
    'kendo.fileselect.invalidMinFileSize': 'Dimensiune fișier prea mică.',
    'kendo.fileselect.remove': 'Șterge',
    'kendo.fileselect.retry': 'Reîncercare',
    'kendo.fileselect.select': 'Selectare fișiere...',
    'kendo.fileselect.uploadSelectedFiles': 'Încărcare fișiere',

    // Scheduler
    // Scheduler
    'kendo.scheduler.agendaViewTitle': 'Agendă',
    'kendo.scheduler.allDay': 'toată ziua',
    'kendo.scheduler.allEvents': 'Toate evenimentele',
    'kendo.scheduler.calendarToday': 'AZI',
    'kendo.scheduler.cancel': 'Anulare',
    'kendo.scheduler.save': 'Salvare',
    'kendo.scheduler.editorEventTitle': 'Titlu',
    'kendo.scheduler.editorEventStart': 'Începe',
    'kendo.scheduler.editorEventStartTimeZone': 'Începe fus orar',
    'kendo.scheduler.editorEventEnd': 'Termină',
    'kendo.scheduler.editorEventEndTimeZone': 'Termină fus orar',
    'kendo.scheduler.dateHeader': 'Data',
    'kendo.scheduler.dayViewTitle': 'Zi',
    'kendo.scheduler.deleteConfirmation': 'Sunteți sigur că doriți să ștergeți acest eveniment?',
    'kendo.scheduler.deleteDialogTitle': 'Șterge Eveniment',
    'kendo.scheduler.deleteOccurrence': 'Șterge ocurența curentă',
    'kendo.scheduler.deleteRecurringConfirmation': 'Doriți să ștergeți doar această ocurență a evenimentului sau întreaga serie?',
    'kendo.scheduler.deleteRecurringDialogTitle': 'Șterge Element Recursiv',
    'kendo.scheduler.deleteSeries': 'Șterge seria',
    'kendo.scheduler.deleteTitle': 'Șterge',
    'kendo.scheduler.destroy': 'Șterge',
    'kendo.scheduler.editOccurrence': 'Editează ocurența curentă',
    'kendo.scheduler.editorEventAllDay': 'Eveniment toată ziua',
    'kendo.scheduler.editorEventDescription': 'Descriere',
    'kendo.scheduler.editorEventSeparateTimeZones': 'Termină în fus orar diferit',
    'kendo.scheduler.editorEventTimeZone': 'Specifică fus orar',
    'kendo.scheduler.editorTitle': 'Eveniment',
    'kendo.scheduler.editRecurringConfirmation': 'Doriți să editați doar această ocurență a evenimentului sau întreaga serie?',
    'kendo.scheduler.editRecurringDialogTitle': 'Editează Element Recursiv',
    'kendo.scheduler.editSeries': 'Editează seria',
    'kendo.scheduler.eventHeader': 'Eveniment',
    'kendo.scheduler.monthViewTitle': 'Lună',
    'kendo.scheduler.multiDayViewTitle': 'Multi-Zi',
    'kendo.scheduler.nextTitle': 'Următor',
    'kendo.scheduler.previousTitle': 'Anterior',
    'kendo.scheduler.recurrenceEditorDailyInterval': 'zi(le)',
    'kendo.scheduler.recurrenceEditorDailyRepeatEvery': 'Repetă la fiecare',
    'kendo.scheduler.recurrenceEditorEndAfter': 'După',
    'kendo.scheduler.recurrenceEditorEndLabel': 'Sfârșit',
    'kendo.scheduler.recurrenceEditorEndNever': 'Niciodată',
    'kendo.scheduler.recurrenceEditorEndOccurrence': 'ocurență',
    'kendo.scheduler.recurrenceEditorEndOn': 'Pe',
    'kendo.scheduler.recurrenceEditorFrequenciesDaily': 'Zilnic',
    'kendo.scheduler.recurrenceEditorFrequenciesMonthly': 'Lunar',
    'kendo.scheduler.recurrenceEditorFrequenciesNever': 'Niciodată',
    'kendo.scheduler.recurrenceEditorFrequenciesWeekly': 'Săptămânal',
    'kendo.scheduler.recurrenceEditorFrequenciesYearly': 'Anual',
    'kendo.scheduler.recurrenceEditorMonthlyDay': 'Zi',
    'kendo.scheduler.recurrenceEditorMonthlyInterval': 'lună(i)',
    'kendo.scheduler.recurrenceEditorMonthlyRepeatEvery': 'Repetă la fiecare',
    'kendo.scheduler.recurrenceEditorMonthlyRepeatOn': 'Repetă pe',
    'kendo.scheduler.recurrenceEditorOffsetPositionsFirst': 'Primul',
    'kendo.scheduler.recurrenceEditorOffsetPositionsFourth': 'Al patrulea',
    'kendo.scheduler.recurrenceEditorOffsetPositionsLast': 'Ultimul',
    'kendo.scheduler.recurrenceEditorOffsetPositionsSecond': 'Al doilea',
    'kendo.scheduler.recurrenceEditorOffsetPositionsThird': 'Al treilea',
    'kendo.scheduler.recurrenceEditorRepeat': 'Repetă',
    'kendo.scheduler.recurrenceEditorWeekdaysDay': 'Zi',
    'kendo.scheduler.recurrenceEditorWeekdaysWeekday': 'Zi lucrătoare',
    'kendo.scheduler.recurrenceEditorWeekdaysWeekendday': 'Zi de weekend',
    'kendo.scheduler.recurrenceEditorWeeklyInterval': 'săptămână(i)',
    'kendo.scheduler.recurrenceEditorWeeklyRepeatEvery': 'Repetă la fiecare',
    'kendo.scheduler.recurrenceEditorWeeklyRepeatOn': 'Repetă pe',
    'kendo.scheduler.recurrenceEditorYearlyInterval': 'an(i)',
    'kendo.scheduler.recurrenceEditorYearlyOf': 'de',
    'kendo.scheduler.recurrenceEditorYearlyRepeatEvery': 'Repetă la fiecare',
    'kendo.scheduler.recurrenceEditorYearlyRepeatOn': 'Repetă pe',
    'kendo.scheduler.showFullDay': 'Afișează toată ziua',
    'kendo.scheduler.showWorkDay': 'Afișează orele de lucru',
    'kendo.scheduler.timeHeader': 'Ora',
    'kendo.scheduler.timelineMonthViewTitle': 'Cronologie Lună',
    'kendo.scheduler.timelineViewTitle': 'Cronologie',
    'kendo.scheduler.timelineWeekViewTitle': 'Cronologie Săptămână',
    'kendo.scheduler.today': 'Astăzi',
    'kendo.scheduler.weekViewTitle': 'Săptămână',
    'kendo.scheduler.workWeekViewTitle': 'Săptămână de lucru',

    // RecurrenceEditor
    'kendo.recurrenceeditor.dailyInterval': 'zi(le)',
    'kendo.recurrenceeditor.dailyRepeatEvery': 'Repetă la fiecare',
    'kendo.recurrenceeditor.endAfter': 'După',
    'kendo.recurrenceeditor.endLabel': 'Sfârșit',
    'kendo.recurrenceeditor.endNever': 'Niciodată',
    'kendo.recurrenceeditor.endOccurrence': 'apariții',
    'kendo.recurrenceeditor.endOn': 'Pe',
    'kendo.recurrenceeditor.frequenciesDaily': 'Zilnic',
    'kendo.recurrenceeditor.frequenciesMonthly': 'Lunar',
    'kendo.recurrenceeditor.frequenciesNever': 'Niciodată',
    'kendo.recurrenceeditor.frequenciesWeekly': 'Săptămânal',
    'kendo.recurrenceeditor.frequenciesYearly': 'Anual',
    'kendo.recurrenceeditor.monthlyDay': 'Zi',
    'kendo.recurrenceeditor.monthlyInterval': 'lună(i)',
    'kendo.recurrenceeditor.monthlyRepeatEvery': 'Repetă la fiecare',
    'kendo.recurrenceeditor.monthlyRepeatOn': 'Repetă pe',
    'kendo.recurrenceeditor.offsetPositionsFourth': 'Al patrulea',
    'kendo.recurrenceeditor.offsetPositionsLast': 'Ultim',
    'kendo.recurrenceeditor.offsetPositionsSecond': 'Al doilea',
    'kendo.recurrenceeditor.offsetPositionsThird': 'Al treilea',
    'kendo.recurrenceeditor.repeat': 'Repetă',
    'kendo.recurrenceeditor.weekdaysDay': 'Zi',
    'kendo.recurrenceeditor.weekdaysWeekday': 'Zi lucrătoare',
    'kendo.recurrenceeditor.weekdaysWeekendday': 'Zi de weekend',
    'kendo.recurrenceeditor.weeklyInterval': 'săptămână(i)',
    'kendo.recurrenceeditor.weeklyRepeatEvery': 'Repetă la fiecare',
    'kendo.recurrenceeditor.weeklyRepeatOn': 'Repetă pe',
    'kendo.recurrenceeditor.yearlyInterval': 'an(i)',
    'kendo.recurrenceeditor.yearlyOf': 'de',
    'kendo.recurrenceeditor.yearlyRepeatEvery': 'Repetă la fiecare',
    'kendo.recurrenceeditor.yearlyRepeatOn': 'Repetă pe',

    //Filter
    'kendo.filter.addExpression': 'Adaugă expresie',
    'kendo.filter.addFilter': 'Adaugă Filtru',
    'kendo.filter.addGroup': 'Adaugă Grup',
    'kendo.filter.remove': 'Șterge',
    'kendo.filter.editorDateTodayText': 'Astăzi',
    'kendo.filter.editorDateToggleText': 'Glisează calendar',
    'kendo.filter.editorNumericDecrement': 'Decrementează valoare',
    'kendo.filter.editorNumericIncrement': 'Incrementează valoare',
    'kendo.filter.filterAfterOperator': 'După',
    'kendo.filter.filterAfterOrEqualOperator': 'După sau egal',
    'kendo.filter.filterAndLogic': 'Și',
    'kendo.filter.filterBeforeOperator': 'Înainte',
    'kendo.filter.filterBeforeOrEqualOperator': 'Înainte sau egal',
    'kendo.filter.filterBooleanAll': '(Tot)',
    'kendo.filter.filterContainsOperator': 'Conține',
    'kendo.filter.filterEndsWithOperator': 'Se termină',
    'kendo.filter.filterEqOperator': 'Egal',
    'kendo.filter.filterExpressionFilters': 'Filtre',
    'kendo.filter.filterExpressionOperators': 'Operatori',
    'kendo.filter.filterGtOperator': 'Mai mare',
    'kendo.filter.filterGteOperator': 'Mai mare sau egal',
    'kendo.filter.filterIsEmptyOperator': 'Gol',
    'kendo.filter.filterIsFalse': 'Fals',
    'kendo.filter.filterIsTrue': 'Adevarat',
    'kendo.filter.filterIsNotEmptyOperator': 'Nu este gol',
    'kendo.filter.filterIsNotNullOperator': 'Definit',
    'kendo.filter.filterIsNullOperator': 'Nedefinit',
    'kendo.filter.filterLtOperator': 'Mai mic',
    'kendo.filter.filterLteOperator': 'Mai mic sau egal',
    'kendo.filter.filterNotContainsOperator': 'Conține',
    'kendo.filter.filterNotEqOperator': 'Diferit',
    'kendo.filter.filterOrLogic': 'Sau',
    'kendo.filter.filterStartsWithOperator': 'Incepe',
    'kendo.filter.filterFieldAriaLabel': 'câmp',
    'kendo.filter.filterOperatorAriaLabel': 'operator',
    'kendo.filter.filterValueAriaLabel': 'valoare',
    'kendo.filter.filterAriaLabel': 'filtru',
    'kendo.filter.filterToolbarAriaLabel': 'setări filtru'
};
